/**
 * Clients HTTP service (PX-W6.2) — the L2 client-boundary endpoints, over the
 * ONE shared transport with `{orgId}` placeholders.
 *
 * `update` takes the complete editable payload by design: the server saves
 * the patch row wholesale (ClientApplicationService.updateClient), so sending
 * a sparse body would null profile/contacts/commercialTerms/dataRoomRoot.
 * The identity fields (`organisationId`, ACLs) are never sent — the server
 * re-stamps them (INV-8).
 */

import { apiClient } from '@/services'

import type { ApiClientProject, ApiClientRow, ClientInput } from './types'

export const clientsHttp = {
  list(): Promise<ApiClientRow[]> {
    return apiClient.get<ApiClientRow[]>('/{orgId}/clients')
  },

  get(clientId: string): Promise<ApiClientRow> {
    return apiClient.get<ApiClientRow>(`/{orgId}/clients/${clientId}`)
  },

  create(input: ClientInput): Promise<ApiClientRow> {
    return apiClient.post<ApiClientRow>('/{orgId}/clients', input)
  },

  update(clientId: string, input: ClientInput): Promise<ApiClientRow> {
    return apiClient.put<ApiClientRow>(`/{orgId}/clients/${clientId}`, input)
  },

  projects(clientId: string): Promise<ApiClientProject[]> {
    return apiClient.get<ApiClientProject[]>(`/{orgId}/clients/${clientId}/projects`)
  }
}
